import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import MultiCurrency from 'tradera-components/multi-currency/multi-currency';

const PaymentSummary = ({
    formattedPrice,
    shippingOptions,
    isSellpyCheckout,
    totalPrice
}) => {
    const { t } = useTranslator();
    const showShippingSelectionRow =
        shippingOptions.length > 1 ||
        (isSellpyCheckout && shippingOptions.length > 0);

    return (
        <>
            <div
                className={`row mt-2 mt-md-4 ${
                    showShippingSelectionRow ? 'mb-2' : 'mb-4'
                }`}>
                <div className="col">
                    <span className="h4 text-styled">
                        {t('checkout_summary_toPayTitle')}:
                    </span>
                </div>
                <div className="text-right col">
                    <div className="font-weight-bold">
                        {t('checkout_bin_pricePlusShipping', {
                            price: formattedPrice
                        })}
                    </div>
                    <MultiCurrency
                        amountInSek={totalPrice}
                        className="font-weight-normal multicurrency"
                        tagName="div"
                    />
                </div>
            </div>
            {showShippingSelectionRow && (
                <div className="row mb-2 mb-md-4">
                    <div className="font-italic col-10 offset-2 text-right">
                        {isSellpyCheckout
                            ? t('cart_sellpyShipping')
                            : t('checkout_bin_shippingDescription')}
                    </div>
                </div>
            )}
        </>
    );
};

export default PaymentSummary;
